import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          
          // Если скроллим вниз и прошли больше 100px, скрываем хедер
          if (currentScrollY > lastScrollY && currentScrollY > 100) {
            setIsVisible(false);
          } 
          // Если скроллим вверх, показываем хедер
          else if (currentScrollY < lastScrollY) {
            setIsVisible(true);
          }
          // В самом верху страницы всегда показываем хедер
          if (currentScrollY <= 100) {
            setIsVisible(true);
          }
          
          setLastScrollY(currentScrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <nav className={`navbar navbar-expand-md navbar-dark ${isVisible ? 'header-visible' : 'header-hidden'}`} style={{paddingLeft: 0, paddingRight: 0}}>
      <div className="container-fluid" style={{paddingLeft: '45px', paddingRight: '41px'}}>
        <Link className="navbar-brand mr-auto d-flex align-items-center" to="/" style={{textDecoration: 'none'}}>
          <img src="/images/Pixward_Logo_1.png" alt="Pixward Studios" style={{maxHeight: '50px', width: 'auto'}} />
          <span style={{
            fontFamily: "'Lato', sans-serif",
            fontSize: '1.2em',
            fontWeight: 'bold',
            color: '#fff',
            marginLeft: '1rem',
            textTransform: 'uppercase'
          }}>PIXWARD STUDIOS</span>
        </Link>
        
        <button 
          className="navbar-toggler" 
          type="button" 
          data-toggle="collapse" 
          data-target="#collapsibleNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="collapsibleNavbar">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Training &amp; Simulation</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link nav-link-games" to="/games">Games</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link nav-link-virtual-production" to="/virtual-production">Virtual Production</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;

